// src/Pages/Setup/SetupWizardAdd.jsx
import SetupWizardBase from "./SetupWizardBase.jsx";

export default function SetupWizardAdd(props) {
  return <SetupWizardBase variant="add" {...props} />;
}
